// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02d0ec53","879":"0887c7b4"}[chunkId] + ".chunk.js";
};